import React from "react";

const  AcountPopUp = ({ handleLogout, handleCancel }) =>{


  return (
    <div
      className="modal fade"
      id="logoutModal"
      tabIndex="-1"
      aria-labelledby="logoutModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center">
          <div className="modal-body">
            <div className="d-flex flex-column align-items-center">
              <div
                className="bg-light rounded-circle d-flex justify-content-center align-items-center"
                style={{ width: "50px", height: "50px", marginBottom: "15px" }}
              >
                <i className="text-primary fs-3">?</i>
              </div>
              <h5 className="mb-3">Are you sure you want to logout?</h5>
              <div className="d-flex justify-content-center gap-2">
                <button
                  className="btn btn-outline-primary px-4"
                    data-bs-dismiss="modal"
                  style= {{border: '1px solid #006FFD', color:'#006FFD'}}
                  onClick={handleLogout}
                >
                  Yes
                </button>
                <button
                  className="btn btn-primary px-4 text-white"
                  data-bs-dismiss="modal"
                  onClick={handleCancel}
                  style={{background:'#006FFD'}}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AcountPopUp;
